// Consulta a API de Regularização Suplementar (parceria AASP) pra saber se a
// pessoa logada já foi notificada pela AASP sobre a Inscrição Suplementar, e se
// já pagou a pendência que tinha com eles. Usado só pelo pedido de Inscrição
// Suplementar, antes de decidir se ele cobra taxa ou não (ver DynamicPedidoPage).
//
// GET /inscricao-suplementar/status?cpf=... devolve estes cenários:
//  - 404: pessoa não está na base da AASP — nunca foi notificada, segue o
//    fluxo normal do pedido (com taxa).
//  - 200, necessitaSuplementar:false: a AASP diz que a pessoa não precisa da
//    regularização — segue o fluxo normal (com taxa), pago:true ou false.
//  - 200, necessitaSuplementar:true, pago:true: já foi notificada e já pagou a
//    pendência com a AASP — não pode gerar taxa de novo aqui no portal.
//  - 200, necessitaSuplementar:true, pago:false: já foi notificada mas ainda tem
//    pendência com a AASP — não pode fazer o pedido de forma alguma, precisa
//    resolver com a AASP antes.
import regularizeSuplementarApi from '../../../../services/regularizeSuplementarApi';

export const SITUACAO_SUPLEMENTAR = {
  SEM_PENDENCIA: 'sem_pendencia',
  PAGO: 'pago',
  PENDENTE: 'pendente'
};

const unformatDigits = (value) => String(value || '').replace(/\D/g, '');

export async function consultarStatusSuplementar(cpf) {
  try {
    const { data } = await regularizeSuplementarApi.get('/inscricao-suplementar/status', {
      params: { cpf: unformatDigits(cpf) }
    });

    if (data?.necessitaSuplementar === false) {
      return { situacao: SITUACAO_SUPLEMENTAR.SEM_PENDENCIA, dados: data };
    }

    return {
      situacao: data?.pago ? SITUACAO_SUPLEMENTAR.PAGO : SITUACAO_SUPLEMENTAR.PENDENTE,
      dados: data
    };
  } catch (err) {
    if (err.response?.status === 404) {
      return { situacao: SITUACAO_SUPLEMENTAR.SEM_PENDENCIA, dados: err.response.data };
    }
    throw err;
  }
}
